
/**
 * Formats a date string into a localized date format
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

/**
 * Extracts a text excerpt from HTML content
 */
export const getExcerpt = (content: string, length = 150): string => {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = content;
  const textContent = tempElement.textContent || '';
  return textContent.substring(0, length) + (textContent.length > length ? '...' : '');
};
